import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=570e3d3a&scoped=true"
import script from "./EventCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=570e3d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e3d3a",
  null
  
)

export default component.exports